import { useState } from 'react';
import {
  Box,
  CircularProgress,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SearchRounded } from '@mui/icons-material';

import TenLogo2 from '../../../../assets/horizontal-blue-logo.svg';

import { Card, CardContainer, CardTitle, Div } from './styles';

import {
  Company,
  getTokensLocalStorage,
  Tokens,
  User,
} from '../../../../services';

import { LogoCompanies } from '../../../../components/LogoCompanies';

import useAuthStore from '../../../../store/auth';
import useUserStore from '../../../../store/users';
import useCompanyStore from '../../../../store/companies';

import { createLogForLogin } from '../../utils/create-logs';

export const StepSelectCompany = () => {
  const navigate = useNavigate();

  const tokensLocalStorage = getTokensLocalStorage() as Tokens;

  const { user, setMenuSelected, setUserAuthenticated } = useAuthStore(
    state => state,
  );
  const { setSelectedCompany, companies } = useCompanyStore(state => state);
  const setSelectedUserInCompany = useUserStore(
    state => state.setSelectedUserInCompany,
  );

  const [searchCompany, setSearchCompany] = useState('');

  const companiesFiltering = companies?.filter(
    c =>
      c?.name?.toUpperCase()?.includes(searchCompany?.toUpperCase()) ||
      c?.fancy_name?.toUpperCase()?.includes(searchCompany?.toUpperCase()),
  );

  const companiesFiltered = searchCompany ? companiesFiltering : companies;

  const handleLoginWithCompany = (company: Company) => {
    const userInCompany = company?.users?.find(u => u?.doc === user?.doc);

    if (userInCompany) {
      const userEdited = {
        ...user,
        profile: userInCompany?.profile,
      };

      setUserAuthenticated(userEdited as User, tokensLocalStorage as Tokens);
      setSelectedUserInCompany(userEdited);
    } else {
      setSelectedUserInCompany(user!);
      setUserAuthenticated(user as User, tokensLocalStorage as Tokens);
    }
    setMenuSelected('portal');
    setSelectedCompany(company);

    navigate('home/reunioes');

    createLogForLogin(
      userInCompany as User,
      company.id as string,
      company.name as string,
    );
  };

  return (
    <Div
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap="10px"
      width="100%"
      height="100%"
    >
      <Typography className="title-company">Selecione a empresa</Typography>
      <TextField
        placeholder="Filtrar empresa..."
        variant="standard"
        InputProps={{
          disableUnderline: true,
          endAdornment: <SearchRounded />,
        }}
        value={searchCompany}
        onChange={ev => setSearchCompany(ev.target.value)}
        fullWidth
        sx={{
          backgroundColor: '#EEE',
          borderRadius: '4px',
          height: '56px',
          justifyContent: 'center',
          padding: '16px 12px 16px 16px',
        }}
      />
      <CardContainer>
        {companiesFiltered && companiesFiltered?.length > 0 ? (
          companiesFiltered?.map((c: Company) => (
            <Card key={c?.id} onClick={() => handleLoginWithCompany(c)}>
              <Box display="flex" width="91%" alignItems="center" gap="20px">
                <Box width="22%" height="70px" marginLeft="20px">
                  <LogoCompanies
                    url={c.logo_url ? (c?.logo_url as string) : TenLogo2}
                    height="70%"
                    boxWidth="74px"
                    maxWidth="100%"
                    width="250px"
                    justifyContent="center"
                  />
                </Box>
                <Tooltip title={c.name}>
                  <CardTitle>{c.fancy_name ? c.fancy_name : c.name}</CardTitle>
                </Tooltip>
              </Box>
            </Card>
          ))
        ) : (
          <CircularProgress />
        )}
        {companiesFiltered.length === 0 && (
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: '700',
              color: '#9E9E9E',
              textAlign: 'center',
              marginTop: '20px',
            }}
          >
            Nenhuma empresa encontrada com este nome...
          </Typography>
        )}
      </CardContainer>
    </Div>
  );
};
